import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

export const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("dh_user");
    if (stored) {
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, { username, password });
      if (response.data.success) {
        const userData = { ...response.data.user, password };
        setUser(userData);
        localStorage.setItem("dh_user", JSON.stringify(userData));
        return { success: true };
      }
      return { success: false, message: response.data.message };
    } catch (error) {
      const status = error.response?.status;
      const detail = error.response?.data?.detail;
      if (status === 401) {
        return { success: false, message: detail || "Benutzername oder Passwort falsch" };
      }
      return { success: false, message: detail || "Verbindungsfehler. Bitte versuchen Sie es erneut." };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("dh_user");
  };

  // UTF-8 safe Basic Auth header — axios's built-in `auth` uses plain btoa()
  // which throws / truncates on non-Latin-1 characters (e.g. "ergül"). We
  // encode the credentials ourselves so usernames with umlauts work.
  const getAuthHeader = () => {
    if (!user) return {};
    const raw = `${user.username}:${user.password}`;
    const token = window.btoa(unescape(encodeURIComponent(raw)));
    return { headers: { Authorization: `Basic ${token}` } };
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  );
};
